import { Routes, Route } from 'react-router-dom';
import { StackHandler } from '@stackframe/react';
import { AppLayout } from '@/components/hoc/AppLayout';
import type { NavigationItemType } from '@/types/nav.types';
import { NotFoundPage } from '../pages/NotFoundPage';
import { ProtectedRoute } from '@/routes/ProtectedRoute';
import { stackClientApp, isNeonAuthEnabled } from '@/utils/auth.utils';
import { ClientOnly } from '@/components/platform/ClientOnly';
import { HomePage } from '@/pages/HomePage';
import { Home } from 'lucide-react';

const routeList: NavigationItemType[] = [
  {
    path: '/',
    title: 'Home',
    icon: Home,
    element: <HomePage />,
    isProtected: false,
    isInternal: false,
  },
];

const protectedNavigationItems: NavigationItemType[] = routeList.filter(
  route => route.isProtected
);
const publicNavigationItems: NavigationItemType[] = routeList.filter(
  route => !route.isProtected
);

// The workflow will generate Pages and Routes
export const AppRoutes = () => {
  return (
    <Routes>
      {/* Auth handler routes - wrapped in ClientOnly to prevent hydration mismatch */}
      {isNeonAuthEnabled && stackClientApp && (
        <Route
          path="/handler/*"
          element={
            <ClientOnly fallback={<div>Loading...</div>}>
              <StackHandler
                app={stackClientApp}
                location={window.location.pathname}
                fullPage
              />
            </ClientOnly>
          }
        />
      )}
      <Route element={<AppLayout navigationItems={routeList} appName="App" />}>
        {publicNavigationItems.map(route => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}
        {protectedNavigationItems.map(route => (
          <Route
            key={route.path}
            path={route.path}
            element={<ProtectedRoute>{route.element}</ProtectedRoute>}
          />
        ))}
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};
